import { useQuery, useMutation, useIsMutating, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  getProjectSimulator,
  postProjectSimulator,
  patchProjectSimulator,
  postProjectFromSimulator,
} from '../../../apiCallFunctions/projectSimulator';
import { updateProjectSimulatorValue } from '../../../actions/projectSimulator';
import { useDispatch } from 'react-redux';
import { FormValues } from '../../../app/simulator/ProjectSimulator/utils';

export const useGetProjectSimulator = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { mutate, isLoading: isPostProjectLoading } = useMutation({
    mutationFn: () => postProjectSimulator(),
    onSuccess: (data) => {
      queryClient.setQueryData('getProjectSimulator', () => data);
    },
    retry: false,
  });

  const query = useQuery({
    queryKey: 'getProjectSimulator',
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: () => getProjectSimulator(),
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 404) {
          return mutate();
        }
      }
    },
    onSuccess: (data) => {
      const isPatched: boolean =
        data.data.ProjectOption.projectSimulatorBody.isPatched;
      dispatch(updateProjectSimulatorValue('isPatched', isPatched));
    },
  });

  return { ...query, isPostProjectLoading };
};

export const usePatchProjectSimulator = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { isLoading, ...mutation } = useMutation({
    mutationKey: 'patchProjectSimulator',
    mutationFn: (form: FormValues) =>
      patchProjectSimulator({
        ...form,
        isPatched: true,
      }),
    onSuccess: (data) => {
      queryClient.setQueryData('getProjectSimulator', () => data);
      dispatch(updateProjectSimulatorValue('isPatched', true));
    },
    retry: false,
  });
  const isMutating = useIsMutating({ mutationKey: 'patchProjectSimulator' });

  return { ...mutation, isLoading: isMutating > 0 };
};

export const usePostProjectFromSimulator = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  return useMutation({
    mutationFn: ({ name, companyId }: { name: string; companyId: number }) =>
      postProjectFromSimulator({ name, companyId }),
    onSuccess: (data) => {
      const redirectionId: number = data.data;
      history.push(`/projects/${redirectionId}`);
      dispatch(updateProjectSimulatorValue('isPatched', false));
    },
  });
};
